import { Box, Text } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

export default function MenuItemComponent({ index, menuText, selected, clickHandler, Component, link, bgColor }) {
    const history = useHistory()

    const menuClickHandler = () => {
        clickHandler(index)
        history.push(link)
    }
    return (
        <Box
            d={['none', 'none', 'none', 'flex']}
            justifyContent='center'
            flexDir='column'
            position='relative'
            alignItems='center'
            cursor='pointer'
            onClick={menuClickHandler}
            height='100%'
        >
            <Component width='24px' height='24px' style={{ fill: selected ? bgColor : menuText === 'Certificates' ? 'white' : '#93a2ba'}} />
            <Text
                color={selected ? bgColor : '#93a2ba'}
                style={{ fontFamily: 'Mulish, sans-serif' }}
                fontWeight='700'
                fontSize='15px'
                mt='1.5'
                
            >
                {menuText}
            </Text>
            <Box w='95%' bottom='0' position='absolute' borderTopWidth='5px' borderTopStyle='solid' borderTopColor={selected ? bgColor : 'transparent'} borderTopRadius='5px'></Box>

        </Box>
    )
}